<template>
    <div data-test-view="reviews-cycles-edit-status-participant-add">
        <div v-if="!participant.reviewee.user">
            <div id="modal-body">
                <h4><l-text :text="$t(`reviews.updateParticipant.labelParticipant`)" /></h4>

                <l-space :size="1" />

                <l-input-typeahead
                    :label="$t(`reviews.updateParticipant.labelName`)"
                    :placeholder="``"
                    :data="users"
                    :on-select="addParticipantAsOwner"
                    :on-input-change="typeaheadUsersOnInput"
                />
            </div>
            <div id="modal-footer" style="text-align: right; margin-top: 20px">
                <button class="btn btn-default" type="button" @click="cancel()">
                    {{ $t(`reviews.updateParticipant.btnCancel`) }}
                </button>
            </div>
        </div>
        <div v-if="participant.reviewee.user">
            <l-reviews-cycles-edit-participant-form
                :user="participant"
                :review-cycle="reviewCycle"
                is-new
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import format from "@/utils/format-typeahead";

import LInputTypeahead from "@/components/LInputTypeahead";
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";

import LReviewsCyclesEditParticipantForm from "@/components/LReviewsCyclesEditParticipantForm";

export default {
    components: {
        LInputTypeahead,
        LSpace,
        LText,

        LReviewsCyclesEditParticipantForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            reviewCycle: {},
            participant: {
                reviewee: {
                    user: "",
                    fullname: "",
                    status: "",
                },
                managers: [],
                additionalManagers: [],
                peers: [],
                directReports: [],
            },
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            rights: "users/current/rights",
            getCycleDetails: "reviews/cycles/details",
            usersSearchList: "users/search/list",
        }),

        users() {
            return this.usersSearchList.map(user => ({ ...user, ...format.users(user) }));
        },
        sort() {
            // For cycles which were created as employee/manager only direct report invitations
            // are allowed. Admins can add any user though.
            if (
                ["manager", "employee"].includes(this.reviewCycle.createdAsRole) &&
                !this.rights?.R_EDIT_ALL
            ) {
                return "reportsSearch";
            }

            return "default";
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.reviewCycle = this.getCycleDetails(this.id);
            },
        },
    },
    methods: {
        addParticipantAsOwner(user) {
            this.$store.dispatch("users/search/reset");

            // add manager or managerOverwrittenBy

            let manager;

            if (
                this.reviewCycle.managerOverwritten &&
                this.reviewCycle.managerOverwrittenBy &&
                this.reviewCycle.managerOverwrittenBy._id
            ) {
                manager = {
                    user: this.reviewCycle.managerOverwrittenBy._id,
                    fullname: this.reviewCycle.managerOverwrittenBy.fullname,
                    status: "pending",
                };
            } else {
                manager = {
                    user: user.teamRole.reportsTo ? user.teamRole.reportsTo._id : this.user._id, // this mean our manager can't be empty
                    fullname: user.teamRole.reportsTo
                        ? user.teamRole.reportsTo.fullname
                        : this.user.firstname + " " + this.user.lastname,
                    status: "pending",
                };
            }

            this.participant = {
                reviewee: {
                    user: user._id,
                    fullname: user.fullname,
                    status: "pending",
                },
                managers: [manager],
                additionalManagers: user.teamRole.additionalManagers
                    ? user.teamRole.additionalManagers.map(function(am) {
                          return {
                              user: am._id,
                              fullname: am.fullname,
                              status: "pending",
                          };
                      })
                    : [],
                peers: [],
                directReports: [],
            };

            this.$nextTick(() => {
                document.querySelector(`.l-modal-backdrop`).scrollTo(0, 0);
            });
        },
        typeaheadUsersOnInput(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query, sort: this.sort });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },

        cancel() {
            this.$router.push(`/reviews/cycles/edit/${this.id}/status`);
        },
    },
};
</script>
